// Health score color ramp (red → orange → yellow → green), shared by the job
// overview gauge (JobStats) and the job-page metrics strip so both read from
// one source. Offsets are percentages along a 0–100 score.
interface HealthGradientStop {
  offset: number;
  color: string;
}

const STOPS: HealthGradientStop[] = [
  { offset: 0, color: "rgb(212,130,128)" },
  { offset: 31, color: "rgb(227,168,117)" },
  { offset: 68, color: "rgb(242,217,145)" },
  { offset: 100, color: "rgb(135,196,148)" },
];

export const jobHealthGradient = {
  stops: STOPS,
  // Horizontal CSS gradient for bar fills.
  cssLinearGradient: `linear-gradient(90deg, ${STOPS.map(
    (stop) => `${stop.color} ${stop.offset.toString()}%`,
  ).join(", ")})`,
};
